module.exports = __webpack_public_path__ + "img/qiancai-back-code.1887f6eb.png";